import React from "react";
import ReactHtmlParser from 'react-html-parser';

export const TeamMember = (props) => {
    const {data} = props;

    return (
        <div className="container">
            <div className="row">
                <section className="col-12">
                    <h2>{data.header}</h2>
                    <span>{data.unit}</span>
                    <span>
                        { data.url && <a className="radical-word-break" href={'http://' + data.url}>{data.url}<br/></a> }
                        <a href={'mailto:' + data.email}>{data.email}</a>
                    </span>
                    <p>{ReactHtmlParser(data.description)}</p>
                    <div className="photo-in-paragraph">
                        <img src={data.image}
                             srcSet={`${data.smallImage} 900w, ${data.image} 1500w`}
                             className="img-fluid" alt={data.header}/>
                    </div>
                </section>
            </div>
        </div>
    )
};
